import MainSlider from "components/Slider/BlazeSlider/BlazeSlider";
import SectionTitle from "components/typography/SectionTitle/SectionTitle";
import SafeMarkdown from "components/ui/SafeMarkdown/SafeMarkdown";
import { useInView } from "react-cool-inview";
import { generateBlazeSlides } from "utils/sliders";

import styles from "./ImpactArea.module.scss";

const ImpactArea = ({ about }) => {
  const formattedSlides = about?.ourImapctSlider.map((slide) => {
    return { ...slide, sliderImage: slide?.sliderImage?.data?.attributes };
  });

  const slides = generateBlazeSlides({
    slides: formattedSlides,
    desktopWidth: 636,
    desktopHeight: 445,
    mobileWidth: 696,
    mobileHeight: 487,
    props: {
      sizes: "(min-width: 992px) 40vw, (min-width: 320px) 100vw, 100vw",
      imageWidth: 635,
      imageHeight: 445,
      aspectRatio: "127/85",
    },
  });

  const { observe, inView } = useInView({ unobserveOnEnter: true });

  return (
    <div className={`${styles.impactArea}`} id="our-impact-about">
      <div className={`${styles.wrapper}`}>
        <div className={`${styles.impactBackground}`} />
      </div>

      <div className="variable-container">
        <div className={`${styles.title}`}>
          <h2>
            <SectionTitle title="Our Impact" color="var(--light-text)" />
          </h2>
          <p>{about?.ourImpactHeader}</p>
        </div>
        <div className={`${styles.row}`}>
          <div className={`${styles.column1}`}>
            <div className={`${styles.sliderWrapper}`} ref={observe}>
              {inView && <MainSlider>{slides}</MainSlider>}
            </div>
          </div>
          <div className={`${styles.column2}`}>
            <SafeMarkdown className={`${styles.text}`}>
              {about?.ourImpactDescription}
            </SafeMarkdown>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactArea;
